import { FormItemsGroup, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { CompanyBankName } from './elements/CompanyBankName'
import { CompanyIban } from './elements/CompanyIban'
import { CompanySwift } from './elements/CompanySwift'

export const CompanyPaymentInfoSection = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <FormItemsGroup rowSpacing={Spacing.S16}>
      <Text variant="h3">
        {t('external_invoices.missing_company_compliance_details.modal.form.payment_info_section.header')}
      </Text>
      <CompanyIban />
      <FormItemsGroup itemsInRow={2}>
        <CompanyBankName />
        <CompanySwift />
      </FormItemsGroup>
    </FormItemsGroup>
  )
}
